import { Box } from "@mui/material";
import { $applyNodeReplacement } from "lexical";
import { useSelectable } from "../utils/use-selectable";
import { DividerNode } from "./divider-node";
import { convertDividerElement, isDividerElement } from "./utils";

import type { InsertDividerCommand } from "../types/commands";
import type { SerializedDividerNode } from "./divider-node";
import type { DOMConversionMap, NodeKey } from "lexical";
import type { FC } from "react";

const DividerComponent: FC<{ nodeKey: NodeKey; divider: InsertDividerCommand }> = ({
  nodeKey,
  divider,
}) => {
  const isSelected = useSelectable(nodeKey);

  return (
    <Box
      className="editor-hr"
      sx={{
        border: isSelected ? "solid 1px" : "none",
        borderColor: "primary.main",
        p: "3px",
      }}
    >
      <hr className={divider ? divider.type : undefined} />
    </Box>
  );
};

export class DividerNodeMui extends DividerNode {
  decorate(): React.JSX.Element {
    return <DividerComponent nodeKey={this.__key} divider={this.__divider} />;
  }
  static importJSON(node: SerializedDividerNode): DividerNode {
    return super.importJSON(node);
  }
  exportJSON(): SerializedDividerNode {
    return super.exportJSON();
  }
  static clone(node: DividerNode): DividerNode {
    return super.clone(node);
  }
  static getType(): string {
    return super.getType();
  }

  static importDOM(): DOMConversionMap | null {
    return {
      hr: (node: HTMLElement) => {
        if (!isDividerElement(node)) return null;

        return {
          conversion: (n) => convertDividerElement(n, DividerNodeMui),
          priority: 0,
        };
      },
    };
  }
}

export function $createDividerNode(headless: boolean, data?: InsertDividerCommand): DividerNode {
  return $applyNodeReplacement(new (headless ? DividerNode : DividerNodeMui)(data));
}
